import { createActions } from 'redux-actions';

export const UPDATE = 'UPDATE';

export const options = {
  prefix: 'ACTIVE_TASK'
};
export const { update } = createActions(UPDATE, options);
